module.exports = __webpack_public_path__ + "media/images/farey/carousel/partenaire_de_votre_reussite-4ed48774e8ca1ce418252d28ea4cd05a.png";